// Tipos para el sistema de recetas
import type { Ingrediente, UnidadMedida } from './ingredientes';

export type EstadoReceta = 'borrador' | 'disponible' | 'archivada';

// El tipo de plato principal - string genérico, viene dinámicamente de la tabla tipos_plato
export type TipoPlato = string;

// Tag asignable a una receta (catálogo extensible: vegetariano, vegano, …).
// El backend devuelve este shape dentro de Receta.tags.
export interface TagReceta {
  id: number;
  slug: string;
  nombre: string;
  descripcion?: string | null;
  activo: number | boolean;
}

export interface IngredienteReceta {
  id: string;
  recetaId: string;
  ingredienteId: string;
  ingrediente: Ingrediente;
  cantidad: number;
  unidadMedidaId: string;
  unidadMedida: UnidadMedida;
  notas?: string;
  costoLinea?: number; // Costo de este ingrediente en la receta (cantidad * costo_unitario)
  // Campos calculados para mostrar en UI
  stockDisponible?: number;
  stockSuficiente?: boolean;
}

export interface Receta {
  id: string;
  nombre: string;
  descripcion: string;
  tipoPlato: TipoPlato; // Tipo de plato principal - obligatorio, se carga dinámicamente
  porciones: number; // Por defecto 10
  estado: EstadoReceta;
  notasParaCocina?: string;
  costoTotal?: number; // Costo total de la receta
  tags?: TagReceta[]; // Tags asignados (vegetariano, vegano, …). Vacío si no tiene.
  ingredientes: IngredienteReceta[];
  // Campos de auditoría
  fechaCreacion: Date;
  fechaActualizacion: Date;
  usuarioCreadorId: string;
  usuarioCreador: {
    id: string;
    nombre: string;
    email: string;
  };
}

export interface FiltrosRecetas {
  busqueda?: string;
  tipoPlato?: string; // Reemplaza categoria por tipoPlato
  estado?: EstadoReceta;
}

// Tipos para formularios
export interface NuevaRecetaFormData {
  nombre: string;
  descripcion: string;
  tipoPlato: string; // Tipo de plato de casino - obligatorio
  porciones: number;
  notasParaCocina?: string;
}

export interface NuevoIngredienteRecetaFormData {
  ingredienteId: string;
  cantidad: number;
  unidadMedidaId: string;
  notas?: string;
}

// Los tipos de plato se obtienen dinámicamente via TiposPlato.obtenerTodos()

export const ESTADOS_RECETA: {
  value: EstadoReceta;
  label: string;
  color: string;
}[] = [
  {
    value: 'borrador',
    label: 'Borrador',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-900/30 dark:text-gray-400',
  },
  {
    value: 'disponible',
    label: 'Disponible',
    color:
      'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-400',
  },
  {
    value: 'archivada',
    label: 'Archivada',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-400',
  },
];
